import React, {
  useMemo,
} from 'react';

import { selectedDate, TreeNode } from 'types/interfaces';
import { hasChildren, PickerTexts } from 'utils';

import TablePageHeader from 'ui/shared/TablePageHeader';
import { TagsComponent } from 'ui/TagsComponent';

interface TableHeaderProps {
  handleFilterChange: (filter: string, value: string) => void;
  selectedDepartmentsFilter: TreeNode[];
  treeDropDownValue: TreeNode[];
  handleSelectionChange: (selection: TreeNode[]) => void;
  handleDateFilterChange: (selection: selectedDate) => void;
  datepickerDate?: selectedDate;
  handleDeleteTagItem: (taskId: string | number) => void;
  isDepartmentsLoaded: boolean;
}

const PersonAssignmentHistoryHeader: React.FC<TableHeaderProps> = ({
  handleFilterChange,
  selectedDepartmentsFilter,
  treeDropDownValue,
  handleSelectionChange,
  handleDateFilterChange,
  datepickerDate,
  handleDeleteTagItem,
  isDepartmentsLoaded,
}) => {
  const filteredSelection = useMemo(
    () =>
      (selectedDepartmentsFilter as TreeNode[]).filter(
        (node) => !hasChildren(node, treeDropDownValue)
      ),
    [selectedDepartmentsFilter, treeDropDownValue]
  );
  const dropdownValueLenght = selectedDepartmentsFilter.length;

  const treeDropdowns = useMemo(
    () => [
      {
        customWidth: '270px',
        selected: selectedDepartmentsFilter,
        value: treeDropDownValue,
        treeDropdownPlaceholder: PickerTexts.departments(dropdownValueLenght),
        onSelectionChange: handleSelectionChange,
        isLoading: !isDepartmentsLoaded,
        loadingText: 'Участки загружаются...',
        key: 'departments_dropdown',
        isRed: selectedDepartmentsFilter.length === 0,
        mode: 'tree' as const,
        overlayClassName: 'dropdown-tree-hr_fisrtItem'
      }
    ],
    [
      handleSelectionChange,
      isDepartmentsLoaded,
      selectedDepartmentsFilter,
      treeDropDownValue,
    ]
  );

  return (
    <TablePageHeader
      tableName="personAssignmentHistory"
      onGlobalSearchChange={(newValue) =>
        handleFilterChange('global', newValue)
      }
      onDatePickerChange={handleDateFilterChange}
      datepickerDate={datepickerDate!}
      datepickerTooltip={{
        from: 'Фильтрация по дате и времени распределения',
        until: 'Фильтрация по дате и времени распределения'
      }}
      datepicker
      treeDropdowns={treeDropdowns}
      additionalLine={
        selectedDepartmentsFilter.length > 0 ? (
          <div
            style={{ width: '100%', maxHeight: '150px', overflow: 'auto' }}
            id="tags-scroll"
          >
            <TagsComponent
              initialTagsItems={filteredSelection}
              onDelete={handleDeleteTagItem}
            />
          </div>
        ) : (
          <React.Fragment />
        )
      }
    />
  );
};

export default PersonAssignmentHistoryHeader;
